import React, { Component } from 'react';
import { Input, Row, Col, Card, Divider } from 'antd'
import { getRoute } from '../../services/route';
import { withRouter, useParams } from 'react-router-dom';
import { isEmptyObj, renderStringValue } from '../../utils';
import CustomerList from '../../components/customer/CustomerList';

const { Search } = Input;

class RouteDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            route: {},
            dataLoading: false
        }
        this.getData = this.getData.bind(this);
        this.getTruckTypeName = this.getTruckTypeName.bind(this);
    }

    async getData() {
        this.setState({
            dataLoading: true
        }, async () => {
            const { id } = this.props
            const res = await getRoute(id)
            const route = res.data.route
            this.setState({
                route,
                dataLoading: false
            })
        })
    }

    componentWillMount() {
        this.getData()
    }

    getTruckTypeName(truck_type) {
        if (truck_type === "FOUR_WHEEL"){
            return "4 ล้อ"
        }
        else if (truck_type === "SIX_WHEEL"){
            return "6 ล้อ"
        }
        return "-"
    }

    render() {
        const { route } = this.state

        return (
            <div>
                <Divider orientation="center"><span className='name-header'>{route.name}</span></Divider>
                <Row>
                    <Col span={24}>
                        <Card>
                            <Row>
                                <Col xs={12} sm={8} md={8} lg={4} xl={4} xxl={4}>
                                    <p>รายละเอียด:</p>
                                </Col>
                                <Col xs={12} sm={16} md={16} lg={20} xl={20} xxl={20}>
                                    <p>{renderStringValue(route.description)}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={8} md={8} lg={4} xl={4} xxl={4}>
                                    <p>หนักงานขับ:</p>
                                </Col>
                                <Col xs={12} sm={16} md={16} lg={20} xl={20} xxl={20}>
                                    <p>{renderStringValue(route.driver)}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={8} md={8} lg={4} xl={4} xxl={4}>
                                    <p>ทะเบียนรถ:</p>
                                </Col>
                                <Col xs={12} sm={16} md={16} lg={20} xl={20} xxl={20}>
                                    <p>{renderStringValue(route.truck_license)}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={8} md={8} lg={4} xl={4} xxl={4}>
                                    <p>ประเภทรถ:</p>
                                </Col>
                                <Col xs={12} sm={16} md={16} lg={20} xl={20} xxl={20}>
                                    <p>{renderStringValue(this.getTruckTypeName(route.truck_type))}</p>
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>
                <Divider orientation="center">สรุปยอดถัง: {route.total_bucket_count}</Divider>
                <Row>
                    <Col span={24}>
                        <Card>
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                    <p>ถัง A:</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>{route.bucket_a_count}</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>ใบ</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                    <p>ถัง B:</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>{route.bucket_b_count}</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>ใบ</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                    <p>ถัง C:</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>{route.bucket_c_count}</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>ใบ</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                    <p>ถัง D:</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>{route.bucket_d_count}</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>ใบ</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                    <p>ถัง F:</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>{route.bucket_f_count}</p>
                                </Col>
                                <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                                    <p>ใบ</p>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Divider orientation="center">ร้านค้า: {route.customer_count}</Divider>
                <Row>
                    <Col span={24}>
                        {!isEmptyObj(route) && <CustomerList routeId={route.id}/>}
                    </Col>
                </Row>
            </div>
        );
    }
}

function pathParamHook(Component) {
    return function WrappedComponent(props) {
      const { id } = useParams();
      return <Component {...props} id={id} />;
    }
}

export default withRouter(pathParamHook(RouteDetail));